import { formatItalianNumber } from './engine';

/**
 * Tag disponibili per template: template_offer_customer
 *
 * TESTATA:
 *   {internalCode}    - Codice interno preventivo
 *   {offerDate}       - Data preventivo (DD/MM/YYYY)
 *   {customerName}    - Nome cliente
 *   {customerAddress} - Indirizzo cliente
 *   {customerVat}     - P.IVA cliente
 *   {customerPhone}   - Telefono cliente
 *   {customerEmail}   - Email cliente
 *   {externalCode}    - Codice esterno
 *   {salesAgent}      - Agente di vendita
 *   {deliveryAddress} - Indirizzo di consegna
 *   {paymentCondition}- Condizione di pagamento
 *   {incoterms}       - Incoterms
 *   {deliveryDate}    - Data consegna (DD/MM/YYYY)
 *   {vatCondition}    - Condizione IVA
 *   {notesOffer}      - Note preventivo
 *
 * RIGHE (loop {#rows}...{/rows}):
 *   {pos}          - Posizione riga
 *   {code}         - Codice articolo
 *   {description}  - Descrizione
 *   {um}           - Unita di misura
 *   {quantity}     - Quantita
 *   {price}        - Prezzo unitario
 *   {discount}     - Sconto
 *   {total}        - Totale riga
 *   {customsCode}  - Codice doganale
 *
 * TOTALI:
 *   {totalWeight}     - Peso totale
 *   {totalVolume}     - Volume totale
 *   {totalPackages}   - Colli totale
 *   {costSpedizione}  - Costo spedizione
 *   {costImballo}     - Costo imballo
 *   {costIncasso}     - Costo incasso
 *   {totalImponibile} - Totale imponibile
 *   {totalIva}        - Totale IVA
 *   {totalPrice}      - Totale preventivo
 */

export default {
    tags: {
        internalCode: 'internalCode',
        offerDate: { path: 'offerDate', format: 'date' },
        customerName: 'idCustomer.name',
        customerAddress: 'idCustomer.address',
        customerVat: 'idCustomer.vatNumber',
        customerPhone: 'idCustomer.phone',
        customerEmail: 'idCustomer.email',
        externalCode: { path: 'externalCode', default: '-' },
        salesAgent: { path: 'idSalesAgent.name', default: '-' },
        deliveryAddress: { paths: ['address.name', 'address.address'], default: '-' },
        paymentCondition: { path: 'idPaymentCondition.name', default: '-' },
        incoterms: { paths: ['idIncoterms.name', 'idIncoterms'], default: '-' },
        deliveryDate: { path: 'deliveryDate', format: 'date', default: '-' },
        vatCondition: { path: 'idVatCondition.name', default: '-' },
        vatPercentage: { compute: (data) => data.idVatCondition?.percentage != null ? data.idVatCondition.percentage + '%' : '' },
        notesOffer: 'notesOffer',
    },

    rows: {
        source: 'rows',
        tags: {
            pos: '_index',
            code: 'idItemModel.code',
            description: 'name',
            um: { paths: ['measureUnit', 'idItemModel.idMeasureUnit.symbol'], default: 'NR' },
            quantity: { path: 'quantity', format: 'number:2', default: '0,00' },
            price: { path: 'price', format: 'currency:2' },
            discount: { compute: (row) => row.discount1 ? '-' + row.discount1 + '%' : '' },
            total: { path: 'totalRow', format: 'currency:2' },
            customsCode: { paths: ['customsCode', 'idItemModel.customsCode'] },
        }
    },

    computed: (data) => {
        let totalWeight = 0, totalVolume = 0, totalPackages = 0;
        (data.rows || []).forEach(row => {
            totalWeight += parseFloat(row.grossWeight || 0);
            totalVolume += parseFloat(row.volume || 0);
            totalPackages += parseFloat(row.packages || 0);
        });
        return {
            totalWeight: totalWeight.toFixed(3),
            totalVolume: totalVolume.toFixed(3),
            totalPackages: totalPackages.toString(),
            costSpedizione: formatItalianNumber(data.costSpedizione || 0, 2) + ' €',
            costImballo: formatItalianNumber(data.costImballo || 0, 2) + ' €',
            costIncasso: formatItalianNumber(data.costIncasso || 0, 2) + ' €',
            totalImponibile: formatItalianNumber(data.totalImponibile || 0, 2) + ' €',
            totalIva: formatItalianNumber(data.totalIva || 0, 2) + ' €',
            totalPrice: formatItalianNumber(data.totalPrice || 0, 2) + ' €',
        };
    }
};
